import { IRevenueSpendByAccountRevenueDetailsTableLang } from '../../../types/lang'

export const revenueSpendByAccountRevenueDetailsTableLang: IRevenueSpendByAccountRevenueDetailsTableLang = {
	revenue_spend_by_account_revenue_details_table: {
		column_date_click: 'Date Click_ua',
		column_date_sale: 'Date Sale_ua',
		column_revenue: 'Revenue_ua',
		column_offer: 'Offer_ua',
		column_sub_id: 'Sub ID_ua',
		column_sub_id_2: 'Sub ID 2_ua',
		column_campaign_group: 'Campaign Group_ua',
		column_kt_group: 'KT Group_ua',
		column_original_status: 'Original Status_ua',
	}
}